import { useQuery } from '@tanstack/react-query';

import { traerTodasLasPaginas } from '../../lib/paginas.js';
import type { Ticket } from './types.js';

// Todos los tickets, sin filtros: base de las tarjetas de Tickets (mes, en
// progreso, % SLA, CSAT) y de los meses del Dashboard. La API corta en 100 por
// página (antes se pedía limit=1000 y llegaban solo 100), así que se piden
// todas las páginas, igual que en CxC.
export function useTicketsTodos() {
  return useQuery({
    queryKey: ['tickets', 'stats'],
    queryFn: () => traerTodasLasPaginas<Ticket>('/tickets'),
  });
}
